import D2C_HostCloud from './Cloud'

class D2C_HostUpcloud extends D2C_HostCloud {
  static objectType = 'hostType'
  static active = true
  static providerType = 'Upcloud'
  static color = '#8811ff'
  static fields = {
    ...D2C_HostCloud.fields,
    instance: {
      ...D2C_HostCloud.fields.instance,
      reversible: true,
      reversibleReadonly: false,
    },
  }
}

export default D2C_HostUpcloud
